import { Formik, Form } from "formik";
import TextField from "../components/common/TextField";
import Button from "../components/common/Button";

interface CityFormProps {
  initialValues: any;
  validationSchema: any;
  onSubmit: (
    values: any,
    formikHelpers: {
      resetForm: () => void;
    }
  ) => Promise<void>;
  isLoading?: boolean;
}

const sectionTitleClasses = "mr-auto mt-4 text-primary font-semibold";

const CityForm: React.FC<CityFormProps> = ({
  initialValues,
  validationSchema,
  onSubmit,
  isLoading,
}) => {
  console.log("");
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting,
      }) => (
        <Form className="mx-auto w-3/5 flex flex-col items-center mt-12 gap-5">
          {/* City name */}
          <TextField
            id="displayName"
            value={values.displayName}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors}
            touched={touched}
            placeholder="Nom de la ville"
          />

          <h3 className={sectionTitleClasses}>Coordonnées</h3>

          {/* Coordinates row */}
          <div className="grid grid-cols-2 gap-4 w-full">
            <TextField
              id="coordinates[0]"
              value={values.coordinates[0]}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              placeholder="Longitude"
            />

            <TextField
              id="coordinates[1]"
              value={values.coordinates[1]}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              placeholder="Latitude"
            />
          </div>

          <Button
            className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white mt-4"
            disabled={isSubmitting || isLoading}
            type="submit"
          >
            Enregistrer
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default CityForm;
